import React from 'react'
import DashboardLayout, { DashboardPage } from '../layout'
import {makeStyles} from '@material-ui/core'
import {Tabs} from 'antd'
import ToolsAdminPage from './tools'
import UsersAdminPage from './users'
import AuthAccounts from './accounts'
import JobScheduler from './scheduler'
import ScrapyServer from './scrapy_server'

const {TabPane} = Tabs

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%'
    }
}))

/**
 *
 * Admin view page
 *
 * Provides links and view pages that are restricted to the administator user logged in
 *
 * This page is only visible to a user whose `superuser` attributes evaluates to true
 */

const AdminPage = (props) => {
    const classes = useStyles()

    return (
        <DashboardLayout
            selected="admin"
        >
            <DashboardPage
                title="Admin"
                hasCta={false}
            >
                <div className={classes.root}>
                    <Tabs
                        defaultActiveKey="users"
                    >
                        <TabPane tab="Users" key="users">
                            <UsersAdminPage />
                        </TabPane>
                        <TabPane tab="Auth Accounts" key="auth_accounts">
                            <AuthAccounts />
                        </TabPane>
                        <TabPane tab="Job Schedulers" key="job_schedulers">
                            <JobScheduler />
                        </TabPane>
                        <TabPane tab="Scrapy Servers" key="scrapy_servers">
                            <ScrapyServer />
                        </TabPane>
                    </Tabs>
                </div>
            </DashboardPage>
        </DashboardLayout>
    )
}

export default AdminPage
